import {
  EM_DASH,
  formatPercentage,
} from "routes/custom_tables/grid/cellHelpers";

export default function PercentageCell({ value }) {
  return value == null || value === "" ? (
    <span className="tw:text-muted-foreground">{EM_DASH}</span>
  ) : (
    <span className="tw:block tw:truncate">{formatPercentage(value)}</span>
  );
}
